"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _EditorSection = _interopRequireDefault(require("./EditorSection"));

var _EditorContent = _interopRequireDefault(require("./EditorContent"));

var _EditorPreview = _interopRequireDefault(require("./EditorPreview"));

var _EditorSidebar = _interopRequireDefault(require("./EditorSidebar"));

var _PageMenu = _interopRequireDefault(require("./PageMenu"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    zIndex: 1,
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  editor: {
    backgroundColor: "inherit",
    position: "absolute",
    zIndex: 2,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: "100%",
    overflow: "hidden"
  },
  preview: {
    position: "absolute",
    backgroundColor: "#333",
    top: 0,
    right: 0,
    bottom: 0,
    left: "50%",
    overflow: "hidden"
  }
}));

const PageSettings = ({
  expanded = true,
  sidebar,
  menuWidth,
  menu = undefined,
  children
}) => {
  const classes = useStyles();

  const renderSidebar = () => {
    const SidebarTemplate = sidebar && sidebar.template;
    return _react.default.createElement(_EditorSidebar.default, {
      expanded: sidebar && sidebar.id && true
    }, SidebarTemplate && _react.default.createElement(SidebarTemplate, sidebar));
  };

  return _react.default.createElement(_EditorSection.default, {
    elevation: 0,
    className: classes.root,
    "aria-expanded": expanded
  }, menu && _react.default.createElement(_PageMenu.default, {
    menuWidth: menuWidth,
    menu: menu
  }), _react.default.createElement(_EditorContent.default, {
    expanded: true
  }, children), sidebar && renderSidebar());
};

var _default = PageSettings;
exports.default = _default;
module.exports = exports.default;